import { FC, useMemo } from 'react';

import { Droppable } from 'react-beautiful-dnd';

import { DraggableCard } from '.';
import { dealTransformer } from '../transformer';

type PROPS = {
  name: string;
  id: string;
  items?: ReturnType<typeof dealTransformer.dealsBoard>['data'];
  actions?: string[];
  selectedDeals: string[];
  onCheck?: (id: string) => void;
};

const DroppableColumn: FC<PROPS> = ({
  name,
  id,
  items,
  actions,
  selectedDeals,
  onCheck,
}) => {
  const isDone = useMemo(() => actions?.includes('DONE'), [actions]);
  return (
    <div className="inline-flex w-[275px] shrink-0 flex-col">
      <div className="sticky top-0 z-20 mb-5 rounded-[6px] bg-fill-overlay p-[14px]">
        <p className="text-sm font-semibold leading-[22px]">{name}</p>
      </div>
      <Droppable droppableId={id}>
        {(provided) => (
          <div
            className="min-h-[calc(100vh-493px)] pb-10"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {/**
             *TODO: Type this Properly
             */}
            {items?.map((item: any, index: number) => (
              <DraggableCard
                checked={selectedDeals.includes(item?._id)}
                onCheck={onCheck}
                index={index}
                key={item._id}
                id={item._id}
                name={item.name}
                createdAt={item.createdAt}
                amount={item._amount}
                company={item.companyId?.name}
                isDone={isDone}
                contacts={item.leadId}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};

export default DroppableColumn;
